import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  resultPaperDiagramContainer: {
    padding: '2vw',
  },
}));

export default useStyles;
